import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isWidgetDisplayed } from "../../../../../esri/widgets/expandUtils";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import Loader from "../../../../Dashboard/Editor/Loader/Loader";
import { LayerListIcon } from "../../../../Icons";
import LayerListWidget from "../../../../LayerListWidget/LayerList";
import Section from "../UI/Section/Section";
import { LayerListIconContainer } from "./LayerList-styled";

const LayerList = ({ expanded }) => {
  const view = useSelector((state) => state.mapViewReducer.view);
  const operationLayers = useSelector(
    (state) => state.mapViewReducer.operationLayers
  );
  const { config } = useContext(ConfigContext);
  const { t } = useTranslation("common");
  // const [layersLoading, setLayersLoading] = useState(false);
  const [count, setCount] = useState(0);
  const initialLoadFlags = useRef(new Map());

  const hasWidget = useMemo(() => {
    return isWidgetDisplayed(config, "LayerList");
  }, [config]);

  useEffect(() => {
    let handler, timer;
    if (!view) return;

    const handleLayerViewCreate = (event) => {
      try {
        const layerView = event.layerView;
        const id = layerView?.layer?.layerConfig?.id;
        clearTimeout(timer);
        if (id) {
          initialLoadFlags.current.set(id, true);
          setCount((prev) => prev + 1);
        }

        layerView.watch("updating", (updating) => {
          if (id && initialLoadFlags.current.get(id) && !updating) {
            initialLoadFlags.current.set(id, false);
            const hasLoadingLayers = Array.from(
              initialLoadFlags.current.values()
            ).some((flag) => flag);
            timer = setTimeout(() => {
              setCount((prev) => prev + 1);
            }, 500);
          }
        });
      } catch (error) {}
    };

    handler = view.on("layerview-create", handleLayerViewCreate);

    return () => {
      if (handler) {
        handler.remove();
      }
    };
  }, [view, operationLayers]);

  const hasLoadingLayers = useMemo(() => {
    return Array.from(initialLoadFlags.current.values()).some((flag) => flag);
  }, [count]);

  if (!hasWidget) return null;

  return (
    <Section
      className="onboarding-layer-list"
      expanded={expanded}
      title={t("screen.widget.LayerList.name")}
      information={t("screen.widget.LayerList.information")}
      Icon={({ selected }) => (
        <LayerListIconContainer>
          {hasLoadingLayers && (
            <Loader
              color={selected ? "#fff" : "#4a4a4a4a"}
              size="50px"
              position="absolute"
              style={{
                background: "transparent",
                top: 10,
              }}
            />
          )}
          <LayerListIcon className="widget-icon" />
        </LayerListIconContainer>
      )}
      widgetName="LayerList"
    >
      <LayerListWidget
        view={view}
        t={t}
        config={config}
        isWidget={false}
        isSidebar
      />
    </Section>
  );
};

export default LayerList;
